// Thumbnail/ThumbnailControls.js

import React from 'react';

function ThumbnailControls({ settings, onUpdateSettings, language }) {
    const handleInputChange = (key, value) => {
        onUpdateSettings({ [key]: value });
    };

    return (
        <div className="controls">
            <div className="control-group">
                <label htmlFor="mainTitle">
                    {language === 'KR' ? '메인 제목' : 'Main Title'}
                </label>
                <input
                    type="text"
                    id="mainTitle"
                    value={settings.mainTitle}
                    onChange={(e) => handleInputChange('mainTitle', e.target.value)}
                />
            </div>
            
            <div className="control-group">
                <label htmlFor="subTitle">
                    {language === 'KR' ? '부제목' : 'Subtitle'}
                </label>
                <input
                    type="text"
                    id="subTitle"
                    value={settings.subTitle}
                    onChange={(e) => handleInputChange('subTitle', e.target.value)}
                />
            </div>
            
            <div className="control-group">
                <label htmlFor="artist">
                    {language === 'KR' ? '아티스트/정보' : 'Artist/Info'}
                </label>
                <input
                    type="text"
                    id="artist"
                    value={settings.artist}
                    onChange={(e) => handleInputChange('artist', e.target.value)}
                />
            </div>
            
            <div className="control-group">
                <label htmlFor="mainIcon">
                    {language === 'KR' ? '메인 아이콘' : 'Main Icon'}
                </label>
                <select
                    id="mainIcon"
                    value={settings.mainIcon}
                    onChange={(e) => handleInputChange('mainIcon', e.target.value)}
                >
                    <option value=""> None </option>
                    <option value="🎵">🎵 음표</option>
                    <option value="🎧">🎧 헤드폰</option>
                    <option value="🎼">🎼 악보</option>
                    <option value="💕">💕 하트</option>
                    <option value="🌹">🌹 장미</option>
                    <option value="🌟">🌟 별</option>
                    <option value="🌙">🌙 달</option>
                    <option value="☀️">☀️ 태양</option>
                    <option value="🌈">🌈 무지개</option>
                    <option value="📝">📝 글쓰기</option>
                </select>
            </div>
            
            <div className="control-group">
                <label htmlFor="bgColor1">
                    {language === 'KR' ? '배경색 1' : 'Background Color 1'}
                </label>
                <input
                    type="color"
                    id="bgColor1"
                    className="color-input"
                    value={settings.bgColor1}
                    onChange={(e) => handleInputChange('bgColor1', e.target.value)}
                />
            </div>
            
            <div className="control-group">
                <label htmlFor="bgColor2">
                    {language === 'KR' ? '배경색 2' : 'Background Color 2'}
                </label>
                <input
                    type="color"
                    id="bgColor2"
                    className="color-input"
                    value={settings.bgColor2}
                    onChange={(e) => handleInputChange('bgColor2', e.target.value)}
                />
            </div>
            
            <div className="control-group">
                <label htmlFor="textColor">
                    {language === 'KR' ? '텍스트 색상' : 'Text Color'}
                </label>
                <input
                    type="color"
                    id="textColor"
                    className="color-input"
                    value={settings.textColor}
                    onChange={(e) => handleInputChange('textColor', e.target.value)}
                />
            </div>
            
            <div className="control-group">
                <label htmlFor="bgType">
                    {language === 'KR' ? '배경 유형' : 'Background Type'}
                </label>
                <select
                    id="bgType"
                    value={settings.bgType}
                    onChange={(e) => handleInputChange('bgType', e.target.value)}
                >
                    <option value="gradient">
                        {language === 'KR' ? '그라데이션' : 'Gradient'}
                    </option>
                    <option value="solid">
                        {language === 'KR' ? '단색' : 'Solid'}
                    </option>
                    <option value="radial">
                        {language === 'KR' ? '원형 그라데이션' : 'Radial Gradient'}
                    </option>
                    <option value="pattern">
                        {language === 'KR' ? '패턴' : 'Pattern'}
                    </option>
                </select>
            </div>
            
            <div className="control-group">
                <label htmlFor="bgOpacity">
                    {language === 'KR' ? '배경 투명도' : 'Background Opacity'}
                </label>
                <input
                    type="range"
                    id="bgOpacity"
                    min="0"
                    max="100"
                    value={settings.bgOpacity}
                    onChange={(e) => handleInputChange('bgOpacity', parseInt(e.target.value))}
                />
                <span>{settings.bgOpacity}%</span>
            </div>

            <div className="control-group">
                <label htmlFor="fontSize">
                    {language === 'KR' ? '글자 크기' : 'Font Size'}
                </label>
                <input
                    type="range"
                    id="fontSize"
                    min="20"
                    max="60"
                    value={settings.fontSize}
                    onChange={(e) => handleInputChange('fontSize', parseInt(e.target.value))}
                />
                <span>{settings.fontSize}px</span>
            </div>
            
            <div className="control-group">
                <label htmlFor="textShadow">
                    {language === 'KR' ? '텍스트 그림자' : 'Text Shadow'}
                </label>
                <input
                    type="range"
                    id="textShadow"
                    min="0"
                    max="10"
                    value={settings.textShadow}
                    onChange={(e) => handleInputChange('textShadow', parseInt(e.target.value))}
                />
                <span>{settings.textShadow}px</span>
            </div>

            <div className="control-group">
                <label htmlFor="effectSpeed">
                    {language === 'KR' ? '효과 속도' : 'Effect Speed'}
                </label>
                <input
                    type="range"
                    id="effectSpeed"
                    min="0.1"
                    max="2"
                    step="0.1"
                    value={settings.effectSpeed}
                    onChange={(e) => handleInputChange('effectSpeed', parseFloat(e.target.value))}
                />
                <span>{settings.effectSpeed.toFixed(1)}x</span>
            </div>
        </div>
    );
}

export default ThumbnailControls;